"use strict";

import angular from "angular";


angular.module("nucont.accounting.company.demonstrations").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state(
        "nucont.accounting.company.demonstrations.accounting.balancesheet",
        {
            url: "/balancete/:date",
            views: {
                "demonstrationAccountingView@nucont.accounting.company.demonstrations.accounting": {
                    component: "accountingBalanceSheetComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            params: {
                demonstration: { value: "balancete", dynamic: false },
                date: { value: null, dynamic: true },
                source: { value: "contabil" },
                stateIndentifier: { value: "dre" }
            },
            bodyClass: "dre-module"
        }
    );
}
